import React from "react";
import Fade from "react-reveal/Fade";
import Pp from "../../assets/appImages/Avatar.png"
import IconImg from "../../assets/icons/quote-up.svg"
import { BsFillStarFill } from "react-icons/bs";
import AliceCarousel from 'react-alice-carousel';
import { responsiveI } from "./HomePage";

function Testimonial() {
  return (
    <div className="">
      <AliceCarousel 
            mouseTracking
            responsive={responsiveI}
            autoPlayStrategy="default"
            controlsStrategy="alternate"
            autoPlay={true}
            infinite={true}
            keyboardNavigation={false}
            autoPlayInterval={2000}
            disableDotsControls
        >
          {Data?.map((testimonial) => (
              <TestimonialItem item={testimonial} key={testimonial.id} />
          ))}
          </AliceCarousel>
    </div>
  );
}

export default Testimonial;

export const TestimonialItem = ({ item }: { item: any }) => {
  
  return (
    <Fade bottom cascade>
      <div className="container-testimonial-item">
         <div className="content-img-icon-testimonial">
          <img src={item.icon} alt="Auote" />
         </div>
         <div className="container-text-testimonial py-4">
          <p className="text-item-testimonial">{item.text}</p>
         </div>
         <div className="content-footer-testimonial">
          <div className="content-item-footer-testimonial">
            <div className="content-img-pp-testimonial">
              <img src={item.img} alt={item.name} className="img-pp-testimonial" />
            </div>
            <p className="name-user-testimonial">{item.name}</p>
          </div>
          <div className="content-item-footer-testimonial">
            <span className="icon-rate-user-testimonial"> <BsFillStarFill /> </span>
            <p className="name-user-testimonial">{item.rate}</p>
          </div>
         </div>
      </div>
    </Fade>
  );
};

const Data = [
  {
    id: 1,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 2,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 3,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 4,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 5,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 6,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 7,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 8,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
  {
    id: 9,
    text: "Pellentesque etiam blandit in tincidunt at donec. Eget ipsum dignissim placerat nisi, adipiscing mauris non. ",
    img: Pp,
    icon: IconImg,
    name: "Cobocannaeru",
    rate: "4.3"
  },
]
